import { id } from "date-fns/locale";
import { useEffect, useRef, useState } from "react"
import classes from './UserManagementList.module.css'
import { useDispatch, useSelector } from "react-redux";
import { Await, useNavigate } from "react-router-dom";
import Pill_Widget from "../../components/UI/Widgets/Pill_Widget";
import UseTimeDateFormat from "../../components/hooks/UseTimeDateFormat";
import ListCard from "../../components/GridList/ListCard";
import BasicTable from "../../components/Table/Table/Table";
import { authActions } from "../../store/auth-Slice";
import DeleteIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png"
import SettingsIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/settings.png"
import deleteIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/delete.png"
import swapSettings from "../../assets/portalAssets/Swap arrow.png"

import Modal from "../../components/Modal/Modal";
import { changePortalRole, deleteGroupUser, deleteUserAccount, enableUserNotifications, switchInstallerMode } from "../../Api Methods/Api";
import Button1 from "../../components/UI/Button/Button1";
import installerActive from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/installer-on.png"
import installerInactive from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/installer off.png"
import ActiveNotificationBellIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/__Notification - On.svg"
import InactiveNotificationBellIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/__Notification - Off.svg"
import DropdownList from "../../components/UI/Cards/DropdownList";
import AdminIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/admin.png"
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import DataManager from "../../hooks/DataManager";
import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import invited from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/invited.png'
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import Lottie from "lottie-react";
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import areYouSureAnim from '../../assets/animations/areYouSure.json'


const UserList = ({data, setData, apiData, isGroup, update, setUpdate, searchQuery, isLoading, setIsLoading, isPortalUsers, hidePortalAccess}) => {
    console.log(data);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = useSelector(state => state.auth.token);
    const client = useSelector(state => state.auth.client);
    const role = useSelector(state => state.auth.role);
    console.log(role);
    const [selectedUsers, setSelectedUsers] = useState([])
    const [successVisible, setSuccessVisible] = useState(false)
    const [failVisible, setFailVisible] = useState(false)
    const [confirmVisible, setConfirmVisible] = useState(false)
    const [userIDToDelete, setUserIDToDelete] = useState(null)
    const [selectedEmail, setSelectedEmail] = useState("")
    const [revokeVisible, setRevokeVisible] = useState(false)
    const [userIDToRevoke, setUserIDToRevoke] = useState(null)
    const [emailPopupVisible, setEmailPopupVisible] = useState(false)
    const [emailPopupRow, setEmailPopupRow] = useState(null)

    const [massActionsVisible, setMassActionsVisible] = useState(false)
    const [roleDialogVisible, setRoleDialogVisible] = useState(false)
    const [roleChangeLoading, setRoleChangeLoading] = useState(false)
    const [singleRoleUser, setSingleRoleUser] = useState(null)
    const [massRevokeVisible, setMassRevokeVisible] = useState(false)
    const [massRevokeLoading, setMassRevokeLoading] = useState(false)

    const massActionOptions = [
        { label: 'Change portal role', value: 'changeRole' },
        { label: 'Revoke access', value: 'revokeAccess' },
    ]

    const roleOptions = role === 'admin'
        ? ['Admin', 'Manager', 'Operator']
        : ['Manager', 'Operator']

    const ApiData = {
        token,
        client
    }
    const dataManager = new DataManager();

    const toggleUserSelection = (user) => {
        setSelectedUsers(prev =>
            prev.some(u => u.userID === user.userID)
                ? prev.filter(u => u.userID !== user.userID)
                : [...prev, user]
        )
    }

    const canActOnUser = (targetPortalRole) => {
        console.log(targetPortalRole);
        if (role === "admin") return true;
        if (role === "TechSupport") return targetPortalRole !== "admin";
        return false;
    };

    const canViewRoles = (targetPortalRole) => {
        console.log(targetPortalRole);
        if (role === "operator") return false;
        return true;
    };

    const handleMassAction = (action) => {
        if (action === 'changeRole') setRoleDialogVisible(true)
        if (action === 'revokeAccess') setMassRevokeVisible(true)
    }

    const handleMassRevoke = async () => {
        setMassRevokeLoading(true)
        await Promise.all(
            selectedUsers.map(user => deleteGroupUser(ApiData, user.userID, dispatch))
        )
        setMassRevokeLoading(false)
        setMassRevokeVisible(false)
        setSelectedUsers([])
        setUpdate(prev => prev + 1)
    }

    const handleMassRoleChange = async (newRole) => {
        setRoleChangeLoading(true)
        if (singleRoleUser) {
            await changePortalRole(ApiData, { userID: singleRoleUser.userID, newRole }, dispatch)
        } else {
            await Promise.all(
                selectedUsers.map(user =>
                    changePortalRole(ApiData, { userID: user.userID, newRole }, dispatch)
                )
            )
            setSelectedUsers([])
        }
        setRoleChangeLoading(false)
        setRoleDialogVisible(false)
        setSingleRoleUser(null)
        setUpdate(prev => prev + 1)
    }

    const navigateToUserSites = (row) => {
        console.log(row);
        const userID = row.userID ?? row.id;
        const fullName = row.fullName
        dataManager.setItem('clickedUserID', userID);
        dataManager.setItem('clickedUserEmailAddress', row.email)
        dataManager.setItem('clickedUserObj', row);
        localStorage.setItem('ClickedUserFullName', fullName);
        localStorage.setItem('clickedUserID', userID)
        dispatch(authActions.setClickedUserDetails({ userID, fullName }))
        dataManager.setItem('userSearchQuery', searchQuery)
        navigate("/Dashboard/Users/UserSites");

        //Save what was typed when clicking in, to restore when navigating back
    }

    const handleEmailClick = (row) => {
        setEmailPopupRow(row);
        setEmailPopupVisible(true);
    };

    const [modalTitle, setModalTitle] = useState("title")
    const [modalComponent, setModalComponent] = useState()

    const ModalDialog = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    }


    const HandleDelete = (userID) => {
        setUserIDToRevoke(userID)
        setRevokeVisible(true)
    }

    const DeleteUser = async (userID) => {
        const response = await deleteGroupUser(ApiData, userID, dispatch);
        if (response){
            setUpdate(update+1);
            setRevokeVisible(false)
        }
    }

    const HandleUserAction = async (userAction, userID, notifications, portalAccess, row) => {
        setSelectedEmail(row.email)
        switch (userAction) {
            case "Enable App Admin":
                const enableInstallerMode = async (apiData, userID) => {
                    const response = await switchInstallerMode(apiData, userID, "INSTALLER")
                    if (response) {
                        row.portalAccess = "INSTALLER"
                        setOpenDropdownRowId(null);
                    }
                }

                enableInstallerMode(apiData, userID)
                break;
            case "Disable App Admin":
                const disableInstallerMode = async (apiData, userID) => {
                    const response = await switchInstallerMode(apiData, userID, "")
                    if (response) {
                        row.portalAccess = ""
                        setOpenDropdownRowId(null);
                    }
                }

                disableInstallerMode(apiData, userID)
                break;
            case "Disable Notifications":
                const DisableUserNotifications = async (apiData, userId, notifications) => {
                    const disableNotifications = notifications == "no"
                    const responseData = await enableUserNotifications(apiData, userId, disableNotifications, dispatch)
                    if (responseData) {
                        row.notifications = "no"
                        setOpenDropdownRowId(null);
                    }
                }

                DisableUserNotifications(apiData, userID, notifications);
                break;
            case "Enable Notifications":
                const EnableUserNotifications = async (apiData, userId, notifications) => {
                    const enableNotification = notifications == "yes"
                    const responseData = await enableUserNotifications(apiData, userId, enableNotification, dispatch)
                    if (responseData) {
                        row.notifications = "yes"
                        setOpenDropdownRowId(null);
                    }
                }

                EnableUserNotifications(apiData, userID, notifications);
                break;
            case "Delete user account":
                setUserIDToDelete(userID)
                setConfirmVisible(true)
                break;
            case "Change role":
                setSingleRoleUser({ userID, fullName: row.fullName })
                setRoleDialogVisible(true)
                break;
            case "Revoke access":
                HandleDelete(userID)
                break;
            default:
                console.alert('Invalid option:', userAction);
        }
    }

    // -- Controls the settingCog wheel -------------------------------------- 
    const [openDropdownRowId, setOpenDropdownRowId] = useState(null);

    const DeleteUserAccount = async () => {
        setConfirmVisible(false);
        if (userIDToDelete != null){
            const body = {
                "userID": userIDToDelete
            }
            const response = await deleteUserAccount(apiData, body, dispatch)
            
            if (response.success) {
                //show success? 
                //Refresh user list?
                setData(prevData => prevData.filter(user => user.id !== userIDToDelete));
                setSuccessVisible(true)
                setOpenDropdownRowId(null);
            } else {
                if (response.msg == "Unauthorised"){
                    setFailVisible(true)
                }
            }
        }
    }

    const handleSettingsClick = (rowId) => {
        // If the clicked dropdown is already open, close it
        if (openDropdownRowId === rowId) {
        setOpenDropdownRowId(null);
        } else {
        // Otherwise, open the clicked dropdown
        setOpenDropdownRowId(rowId);
        }
    };

    useEffect(() => {
        if (Array.isArray(data) && data.length > 0) {
            //setIsLoading(false)
        }
    }, [data]);

    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                // Clicked outside the dropdown menu, so close it
                setOpenDropdownRowId(null);
            }
        };

        // Add event listener to listen for clicks outside the dropdown menu
        document.addEventListener('click', handleClickOutside);

        return () => {
        // Cleanup: Remove event listener when component unmounts
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    // -----------------------------------------------------------------------

    useEffect(() => {
        if (selectedUsers.length > 0) {
            setMassActionsVisible(true)
        } else {
            setMassActionsVisible(false)
        }
    }, [selectedUsers])
    
    const tableColumnsDefault = [
        {
            id: 'name', 
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Name</h3>
                </div>
            ),
            accessorKey: 'fullName',
            cell: (row) => {
                return (
                    <div onClick={() => navigateToUserSites(row.row.original)} 
                        className={classes.tableValueText}>
                        <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={"#6996f1"}
                            PillColor_IfFalse={"#626a67"}
                            text_IfTrue={row.row.original.fullName}
                            className={classes.PillHeight}
                        />
                    </div>
                )
            }
        },
        {
            id: 'email',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Email address</h3>
                </div>
            ),
            accessorKey: 'email',
            cell: (row) => {
                return (
                    <div onClick={() => handleEmailClick(row.row.original)} className={classes.tableValueText} style={{ cursor: "pointer", color: "#1a73e8", textDecoration: "underline" }}>
                        {row.row.original.email}
                    </div>
                )
            }
        },
        {
            id: 'numberOfSites',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Number of sites</h3>
                </div>
            ),
            cell: (row) => {
                const numberOfSites = row.row.original.siteCount
                return (
                    <>
                    <p className={classes.tableTitleText}>{numberOfSites}</p>
                </>
                )
            }
        },
        {
            id: 'Account created', 
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Account created</h3>
                </div>
            ),
            accessorKey: 'lastLoggedIn',
            cell: (row) => {
                const lastLoggedIn = row.row.original.created;
                const displayValue = lastLoggedIn
                ? UseTimeDateFormat(lastLoggedIn)
                : { date: "Never logged in", time: "" };

                const { date, time } = displayValue;
                return (
                    <>
                        <p className={classes.tableTitleText}>{date + ", " + time}</p>
                    </>
                )
            },
        },
        {
            id: 'appAdmin',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                  <h3>App admin</h3>
              </div>
            ), //Grey tick vs green for password vs no password
            accessorKey: 'portalAccess',
            cell: (row) => {
              return (
                <div onClick={() => navigateToUserSites(row.row.original)}>
                    {row.row.original.portalAccess && row.row.original.portalAccess.trim() !== "" && (
                         <img className={classes.Icon} src={AdminIcon} 
                     />
                    )}     
                </div>
              )
            }
          },
          {
            id: 'portalAccess',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                  <h3>Portal access</h3>
              </div>
            ),
            accessorKey: 'portalAccess',
            hidden: !!hidePortalAccess,
            cell: (row) => {
              return (
                <div onClick={() => navigateToUserSites(row.row.original)}>

                    {row.row.original.portalAccess && row.row.original.portalAccess.trim() !== "" && row.row.original.portalAccess.trim() !== "INSTALLER" && row.row.original.portalPassword && row.row.original.portalPassword !== "" && (
                         <img className={classes.Icon} src={check}     
                     />
                    )}  

                    {row.row.original.portalAccess && row.row.original.portalAccess.trim() !== "" && row.row.original.portalAccess.trim() !== "INSTALLER" && row.row.original.portalPassword == "" && (
                         <img className={classes.Icon} src={invited}     
                     />
                    )}  

                </div>
              )
            }
          },
          {
            id: 'notifications',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                  <h3>Notifications enabled</h3>
              </div>
            ),
            accessorKey: 'portalAccess',
            cell: (row) => {
              return (
                <div onClick={() => navigateToUserSites(row.row.original)}>
                    {row.row.original.notifications && row.row.original.notifications.trim() == "yes" && (
                         <img className={classes.Icon} src={AdminIcon}     
                     />
                    )}     
                </div>
              )
            }
          },
          {
            //Settings cog
            id: 'delete',
            cell: (row) => {
                if (!canActOnUser(row.row.original.portalRole)) return null;
                return (
                    <div className={classes["icons-container"]}>
                        <img className={classes.Icon} src={DeleteIcon}
                            onClick={() => HandleDelete(row.row.original.userID)}
                        />
                    </div>
                    )
            },
            hidden: !isGroup || (role !== "admin" && role !== "TechSupport"),
          },
          {
            id: 'userSettings',
            cell: (row) => {
                let items = [
                    {
                        image:
                            row.row.original.notifications == "yes"
                                ? InactiveNotificationBellIcon
                                : ActiveNotificationBellIcon,
                        title:
                            row.row.original.notifications == "yes"
                                ? "Disable Notifications"
                                : "Enable Notifications",
                    },
                    {
                        image:
                            row.row.original.portalAccess != "" && row.row.original.portalAccess != null
                                ? installerInactive
                                : installerActive,
                        title:
                            row.row.original.portalAccess != "" && row.row.original.portalAccess != null
                                ? "Disable App Admin"
                                : "Enable App Admin",

                    },
                ];

                if (canActOnUser(row.row.original.portalRole)) {
                    items.push({ image: deleteIcon, title: "Delete user account" });
                }

                const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
                if (role !== "admin" && role !== "TechSupport") return null;
                return <DropdownList
                    item={row.row.id}
                    icon={SettingsIcon}
                    onClick={handleSettingsClick}
                    ifSettingsCogIsClicked={ifSettingsCogIsClicked}
                    ref={dropdownRef}
                    title={"Actions"}
                    className={classes.container}
                    onUserActionClick={(userAction) =>
                        HandleUserAction(userAction, row.row.original.id, row.row.original.notifications, row.row.original.portalAccess, row.row.original)
                    }
                    listItems={items}
                />
            },
            hidden: isGroup
          },
      ];

    const tableColumnsGroupUsers = [
        {
            id: 'select',
            header: () => null,
            cell: (row) => {
                const user = row.row.original
                const isChecked = selectedUsers.some(u => u.userID === user.userID)
                return (
                    <div onClick={e => e.stopPropagation()}>
                        <Checkbox
                            onChange={() => toggleUserSelection(user)}
                            checked={isChecked}
                        />
                    </div>
                )
            },
            hidden: role !== 'admin',
        },
         {
            id: 'name',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Name</h3>
                </div>
            ),
            accessorKey: 'fullName',
            cell: (row) => {
                return (
                    <div onClick={() => navigateToUserSites(row.row.original)} 
                        className={classes.tableValueText}>
                        <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={"#6996f1"}
                            PillColor_IfFalse={"#626a67"}
                            text_IfTrue={row.row.original.fullName}
                            className={classes.PillHeight}
                        />
                    </div>
                )
            }
        },
        {
            id: 'email',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Email address</h3>
                </div>
            ),
            accessorKey: 'email',
            cell: (row) => {
                return (
                    <div onClick={() => handleEmailClick(row.row.original)} className={classes.tableValueText} style={{ cursor: "pointer", color: "#1a73e8", textDecoration: "underline" }}>
                        {row.row.original.email}
                    </div>
                )
            }
        },

        {
            id: 'lastLoggedin', 
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Last logged in</h3>
                </div>
            ),
            accessorKey: 'lastLoggedIn',
            cell: (row) => {
                const lastLoggedIn = row.row.original.lastLoggedIn;
                const displayValue = lastLoggedIn
                ? UseTimeDateFormat(lastLoggedIn)
                : { date: "Never logged in", time: "" };

                const { date, time } = displayValue;
                return (
                    <>
                        <p className={classes.tableTitleText}>{date + ", " + time}</p>
                    </>
                )
            },
        },
        {
            id: 'portalAccess',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                  <h3>Portal access</h3>
              </div>
            ),
            accessorKey: 'portalAccess',
            cell: (row) => {
              return (
                <div onClick={() => navigateToUserSites(row.row.original)}>

                    {row.row.original.portalAccess && row.row.original.portalAccess.trim() !== "" && row.row.original.portalAccess.trim() !== "INSTALLER" && row.row.original.portalPassword && row.row.original.portalPassword !== "" && (
                         <img className={classes.Icon} src={check}     
                     />
                    )}  

                    {row.row.original.portalAccess && row.row.original.portalAccess.trim() !== "" && row.row.original.portalAccess.trim() !== "INSTALLER" && row.row.original.portalPassword == "" && (
                         <img className={classes.Icon} src={invited}     
                     />
                    )}  

                </div>
              )
            }
          },
          {
            id: 'accessLevel', 
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Role</h3>
                </div>
            ),
            accessorKey: 'portalRole',
            cell: (row) => {
                if (!canViewRoles(row.row.original.portalRole)) return null;
                return (
                    <div
                        className={classes.tableValueText}>
                        <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={"#6996f1"}
                            PillColor_IfFalse={"#626a67"}
                            text_IfTrue={row.row.original.portalRole === "TechSupport" ? "Manager" : row.row.original.portalRole}
                            className={classes.PillHeight}
                        />
                    </div>
                )
            }
        },
          {
            id: 'delete',
            cell: (row) => {
                if (role !== "admin" && role !== "TechSupport") return null;
                const items = [
                    { image: swapSettings, title: "Change role" },
                    { image: DeleteIcon, title: "Revoke access" },
                ];
                const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
                return (
                    <DropdownList
                        item={row.row.id}
                        icon={SettingsIcon}
                        onClick={handleSettingsClick}
                        ifSettingsCogIsClicked={ifSettingsCogIsClicked}
                        ref={dropdownRef}
                        title={"Actions"}
                        className={classes.container}
                        onUserActionClick={(userAction) =>
                            HandleUserAction(userAction, row.row.original.userID, row.row.original.notifications, row.row.original.portalAccess, row.row.original)
                        }
                        listItems={items}
                    />
                )
            },
            hidden: !isGroup || (role !== "admin" && role !== "TechSupport"),
          },
          {
            id: 'userSettings', 
            cell: (row) => {
                let items = [
                    {
                        image:
                            row.row.original.notifications == "yes"
                                ? InactiveNotificationBellIcon
                                : ActiveNotificationBellIcon,
                        title:
                            row.row.original.notifications == "yes"
                                ? "Disable Notifications"
                                : "Enable Notifications",
                    },
                    {
                        image: 
                            row.row.original.portalAccess != "" && row.row.original.portalAccess != null
                                ? installerInactive
                                : installerActive,
                        title: 
                            row.row.original.portalAccess != "" && row.row.original.portalAccess != null
                                ? "Disable App Admin"
                                : "Enable App Admin",
            
                    }
                ];
                
                const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
                return <DropdownList
                    item={row.row.id}
                    icon={SettingsIcon}
                    onClick={handleSettingsClick}
                    ifSettingsCogIsClicked={ifSettingsCogIsClicked}
                    ref={dropdownRef}
                    title={"Actions"}
                    className={classes.container}
                    onUserActionClick={(userAction) => 
                        HandleUserAction(userAction, row.row.original.id, row.row.original.notifications, row.row.original.portalAccess, row.row.original)
                    }
                    listItems={items}
                />
            },
            hidden: isGroup
          },
    ]

    useEffect(() => {
    }, [selectedEmail])

    const tableColumns = isPortalUsers ? tableColumnsGroupUsers : tableColumnsDefault

    const filteredTableColumns = tableColumns.filter(column => !column.hidden);

    return (
        <>
        <Modal ref={ModalDialog} title={modalTitle} modalName={"Site View"} HandleShowModal={HandleShowModal}>
            {modalComponent}
        </Modal>

        

        <Dialog
            header="Success"
            visible={successVisible}
            style={{ width: "40vw" }}
            onHide={() => setSuccessVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff"}}>User account deleted successfully.</h3>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />

                <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setSuccessVisible(false)}/>
            </div>
        </Dialog>

        <Dialog
            header="Error"
            visible={failVisible}
            style={{ width: "40vw" }}
            onHide={() => setFailVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={failAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br/>
                <h3 style={{color:"#6e6e6eff"}}>Unauthorised</h3>
            <p style={{textAlign:"center"}}>You are not authorsied to delete this user account, only users within your domain can be deleted</p>
           <br></br>

                <Button label="Okay" rounded severity="secondary" onClick={() => setFailVisible(false)}/>
            </div>
        </Dialog>

        <Dialog
            header={`Revoke access for ${selectedUsers.length} user${selectedUsers.length !== 1 ? 's' : ''}?`}
            visible={massRevokeVisible}
            style={{ width: "40vw" }}
            onHide={() => setMassRevokeVisible(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={areYouSureAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                <br/>
                <h3 style={{ color: "#6e6e6eff", textAlign: "center" }}>Are you sure you want to revoke access for {selectedUsers.length} user{selectedUsers.length !== 1 ? 's' : ''}?</h3>
                <br/>
                <Button label="No, cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => setMassRevokeVisible(false)} />
                <br/>
                <Button label="Yes, revoke all" rounded icon="pi pi-check" severity="danger" loading={massRevokeLoading} onClick={handleMassRevoke} />
            </div>
        </Dialog>

        <Dialog
            header="Revoke access?"
            visible={revokeVisible}
            style={{ width: "40vw" }}
            onHide={() => setRevokeVisible(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={areYouSureAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br/>
                <h3 style={{ color: "#6e6e6eff", textAlign: "center" }}>Are you sure you want to revoke this user's access?</h3>
                <br/>
                <Button label="No, cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => setRevokeVisible(false)} />
                <br/>
                <Button label="Yes, I'm sure" rounded icon="pi pi-check" severity="danger" onClick={() => DeleteUser(userIDToRevoke)} />
            </div>
        </Dialog>

        <Dialog
            header="Are you sure?"
            visible={confirmVisible}
            style={{ width: "40vw" }}
            onHide={() => setConfirmVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={areYouSureAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
            <br/>
            <h3 style={{color:"#6e6e6eff"}}>{`Are you sure you want to delete ${selectedEmail}`}</h3>
            <p>This is a PERMANENT action and cannot be undone!</p>
                <br/>
                <Button label="No cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => setConfirmVisible(false)}/>
                <br/>
                <Button label="Yes, delete account" rounded icon="pi pi-check" severity="danger" onClick={() => DeleteUserAccount()}/>

            </div>
        </Dialog>

        <Dialog
            header={emailPopupRow?.email}
            visible={emailPopupVisible}
            style={{ width: "fit-content", minWidth: "320px", maxWidth: "90vw" }}
            onHide={() => setEmailPopupVisible(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <Button
                    label="Send email"
                    icon="pi pi-envelope"
                    severity="secondary"
                    outlined
                    style={{ justifyContent: "flex-start" }}
                    onClick={() => {
                        window.location.href = `mailto:${emailPopupRow?.email}`;
                        setEmailPopupVisible(false);
                    }}
                />
                <Button
                    label="View profile"
                    icon="pi pi-user"
                    severity="primary"
                    style={{ justifyContent: "flex-start" }}
                    onClick={() => {
                        setEmailPopupVisible(false);
                        navigateToUserSites(emailPopupRow);
                    }}
                />
            </div>
        </Dialog>

        {massActionsVisible && (role === 'admin' || role === 'TechSupport') && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '8px 4px', marginBottom: '8px' }}>
                <span style={{ fontSize: 'var(--font-normal)', color: '#6e6e6e', whiteSpace: 'nowrap' }}>
                    {selectedUsers.length} user{selectedUsers.length !== 1 ? 's' : ''} selected
                </span>
                <Dropdown
                    value={null}
                    options={massActionOptions}
                    onChange={(e) => handleMassAction(e.value)}
                    placeholder="Actions"
                    style={{ fontSize: 'var(--font-normal)' }}
                />
                <Button
                    label="Clear"
                    icon="pi pi-times"
                    text
                    severity="secondary"
                    onClick={() => setSelectedUsers([])}
                    style={{ fontSize: 'var(--font-normal)', padding: '6px 10px' }}
                />
            </div>
        )}

        <Dialog
            header={singleRoleUser ? `Change role — ${singleRoleUser.fullName}` : `Change portal role — ${selectedUsers.length} user${selectedUsers.length !== 1 ? 's' : ''}`}
            visible={roleDialogVisible}
            style={{ width: '360px' }}
            onHide={() => { setRoleDialogVisible(false); setSingleRoleUser(null); }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <p style={{ color: '#6e6e6e', fontSize: 'var(--font-normal)', marginBottom: '8px' }}>
                    Select the role to assign to all selected users:
                </p>
                {roleOptions.map(r => (
                    <Button
                        key={r}
                        label={r}
                        outlined
                        severity="secondary"
                        loading={roleChangeLoading}
                        onClick={() => handleMassRoleChange(r)}
                        style={{ justifyContent: 'flex-start' }}
                    />
                ))}
            </div>
        </Dialog>

        <div style={{width:"100%"}}>
            <div className={`${classes.center} ${classes.table2}`}>
                <ListCard secondaryClassName={classes["Card-container"]}>
                    <div className={classes["tableCardLayoutUI-wrapper"]} style={{ padding: "0px 10px 0px 10px" }}>
                        <Await resolve={data}>
                            {(loadedTableData) => {
                                return (
                                    <>
                                    <br></br>
                                    <div style={{ width: "auto", minWidth: "500px", height: "100%", minHeight:"500px" }} >
                                        {isLoading ? (
                                            <div style={{ display: "flex", width: "100%" }}>
                                                <DeviceLoadingGrid
                                                CardCount={
                                                    20
                                                }
                                                />
                                            </div>
                                            ) : (
                                            <BasicTable
                                                data={loadedTableData}
                                                columns={filteredTableColumns}
                                                filtering={""}
                                                rowClick={false}
                                                ShowPagination={false}
                                                PageSize={5000}
                                                paginationOptions={[25, 50, 100]}
                                                showFilterButton={false}
                                                isSortable={true}
                                            />
                                            )
                                        }
                                    </div>
                                    </>
                                )
                            }}
                        </Await>
                    </div>
                </ListCard>
            </div>
        </div>
        </>
    )
}

export default UserList;